import { render, staticRenderFns } from "./createChildSizePicture.vue?vue&type=template&id=6749265d&"
import script from "./createChildSizePicture.vue?vue&type=script&lang=js&"
export * from "./createChildSizePicture.vue?vue&type=script&lang=js&"
import style0 from "./createChildSizePicture.vue?vue&type=style&index=0&id=6749265d&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports